import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { forwardRef } from "react";

import { globalConstants } from "@/constants";
import { globalData } from "@/data";

export const Calendar = forwardRef(
    function Calendar(
        {
            dataTestId,
            disabled,
            error,
            isEventCalendar,
            label,
            name,
            onBlur,
            onChange,
            onKeyDown,
            value,
        },
        ref,
    ) {
        dayjs.extend(utc);

        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                    disabled={disabled}
                    format={isEventCalendar ? globalConstants.calendarDateFormat : globalConstants.calendarDateTimeFormat}
                    label={label}
                    openTo={globalData.calendarOpenTo}
                    value={value ? dayjs.utc(value).local() : null}
                    slotProps={{
                        textField: {
                            error,
                            fullWidth: true,
                            inputProps: dataTestId ? { "data-test": dataTestId } : undefined,
                            inputRef: ref,
                            name,
                            onBlur,
                            onKeyDown,
                        },
                    }}
                    views={isEventCalendar ? globalData.calendarViews.slice(
                        0,
                        3,
                    ) : globalData.calendarViews}
                    onChange={(newValue) => onChange(newValue ? newValue.toDate() : null)}
                />
            </LocalizationProvider>
        );
    },
);
